export default function fluidType (target, contentRect, minFontSize, maxFontSize, minContainerWidth, maxContainerWidth) {
  let fontSize = minFontSize + (maxFontSize - minFontSize) * (contentRect.width - minContainerWidth) / (maxContainerWidth - minContainerWidth);

  fontSize = Math.max(minFontSize, Math.min(fontSize, maxFontSize));

  target.style.setProperty('--fluid-type-scale', Math.floor(fontSize / 16 * 100) / 100);
}
